import { render, staticRenderFns } from "./LoanAndBizRouting.vue?vue&type=template&id=e5aa25e0&scoped=true&"
import script from "./LoanAndBizRouting.vue?vue&type=script&lang=js&"
export * from "./LoanAndBizRouting.vue?vue&type=script&lang=js&"
import style0 from "./LoanAndBizRouting.vue?vue&type=style&index=0&id=e5aa25e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5aa25e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
